(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nimall-card-dispatch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nimall-card-dispatch')) {
    customElements.define('nimall-card-dispatch', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.card = this.closest('.product-item, .y01-product-card');
        this.content = this.querySelector('[data-card-dispatch-content]');
        try { this.variants = JSON.parse(this.querySelector('[data-card-dispatch-variants]').textContent); }
        catch { this.variants = {}; }
        const title = this.card?.querySelector('.card-title, .y01-product-card__title a');
        const refresh = () => {
          const href = title?.getAttribute('href') || location.href;
          const id = new URL(href, location.origin).searchParams.get('variant') || this.dataset.initialVariant;
          this.showVariant(id);
          // The legacy swatch handler rewrites every card link. Preserve the reviews destination.
          const review = this.card?.querySelector('.nimall-card-rating');
          if (review && title) {
            const target = new URL(href, location.origin);
            target.hash = 'judgeme_product_reviews';
            review.href = target.href;
          }
        };
        this.card?.addEventListener('click', event => {
          const swatch = event.target.closest('.swatch-label[data-variant-id]');
          if (swatch) this.showVariant(swatch.dataset.variantId);
        }, {signal: this.controller.signal});
        this.observer = new MutationObserver(refresh);
        if (title) this.observer.observe(title, {attributes: true, attributeFilter: ['href']});
        refresh();
      }
      showVariant(id) {
        const data = Object.hasOwn(this.variants, String(id)) ? this.variants[String(id)] : null;
        this.hidden = !Array.isArray(data) || data.length !== 5 || !['AE', 'SA'].includes(data[0]);
        this.dataset.variantId = id == null ? '' : String(id);
        this.content.replaceChildren();
        if (this.hidden) return;
        const flag = document.createElement('span');
        flag.className = 'nimall-card-dispatch__flag'; flag.setAttribute('aria-hidden', 'true'); flag.textContent = data[1];
        const accessible = document.createElement('span');
        accessible.className = 'visually-hidden'; accessible.textContent = this.dataset.shipsLabel + ' ' + data[2] + (data[3] ? '; ' + data[3] + ' ' + data[4] : '');
        const copy = document.createElement('span');
        copy.className = 'nimall-card-dispatch__copy'; copy.setAttribute('aria-hidden', 'true'); copy.append(document.createTextNode(data[2]));
        if (data[3]) {
          const range = document.createElement('bdi'); range.textContent = data[3];
          copy.append(document.createTextNode(' / '), range, document.createTextNode(' ' + data[4]));
        }
        this.content.append(flag, accessible, copy);
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nimall-country-rail"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-country-rail]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      const track=root.querySelector('.nimall-country-rail__track'),dots=[...root.querySelectorAll('[data-country-index]')];
      let current=0,timer;
      const go=i=>track.scrollTo({left:((i+dots.length)%dots.length)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      track.addEventListener('scroll',()=>{current=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((b,i)=>{b.classList.toggle('is-active',i===current);b.setAttribute('aria-current',String(i===current))})},{passive:true});
      dots.forEach((b,i)=>b.addEventListener('click',()=>go(i)));
      track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1))}});
      const stop=()=>clearInterval(timer);
      const start=()=>{stop();if(root.dataset.countryVariant==='desktop'&&!document.hidden&&!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>go(current+1),5200)};
      root.addEventListener('pointerenter',stop);root.addEventListener('pointerleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',()=>requestAnimationFrame(()=>{if(!root.contains(document.activeElement))start()}));document.addEventListener('visibilitychange',start);start();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nimall-desktop-discovery"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = matchMedia('(min-width: 1025px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let timer;
    const initialize = () => {
      clearInterval(timer);
      const input = document.querySelector('#Search-In-Modal-Single');
      const source = document.querySelector('[data-nimall-search-hints]');
      if (!input || !source) return;
      const original = input.dataset.originalPlaceholder || input.placeholder;
      input.dataset.originalPlaceholder = original;
      const hints = source.dataset.nimallSearchHints.split('|').map(value => value.trim()).filter(Boolean);
      let index = 0;
      const reset = () => { input.placeholder = original; };
      input.addEventListener('focus', reset);
      timer = setInterval(() => {
        if (!input.isConnected) { clearInterval(timer); return; }
        if (!desktop.matches || reduced.matches || document.hidden || input.value || document.activeElement === input) return;
        if (hints.length) input.placeholder = hints[index++ % hints.length];
      }, 4200);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nimall-mobile-interest"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nimall-mobile-interest')){
  customElements.define('nimall-mobile-interest',class extends HTMLElement{
    connectedCallback(){
      this.media=matchMedia('(max-width: 767px)');
      this.mount=()=>{
        if(!this.source){
          this.source=document.querySelector('[data-nimall-interest-source]')?.closest('.shopify-section');
          if(!this.source)return;
          this.home=document.createElement('span');this.home.hidden=true;
          this.source.before(this.home);
        }
        if(this.media.matches){if(this.source.parentElement!==this)this.append(this.source);}
        else if(this.home.parentElement&&this.source.parentElement===this)this.home.after(this.source);
      };
      this.media.addEventListener('change',this.mount);
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.mount,{once:true});
      else this.mount();
      document.addEventListener('shopify:section:load',this.mount);
    }
    disconnectedCallback(){
      this.media?.removeEventListener('change',this.mount);
      document.removeEventListener('DOMContentLoaded',this.mount);
      document.removeEventListener('shopify:section:load',this.mount);
      if(this.home?.parentElement&&this.source?.parentElement===this)this.home.after(this.source);
      this.home?.remove();this.source=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nimall-mobile-offer-rail"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nimall-mobile-offer-rail'))customElements.define('nimall-mobile-offer-rail',class extends HTMLElement{
 connectedCallback(){
  if(this.connected)return;this.connected=true;this.controller=new AbortController();const signal=this.controller.signal;
  this.dialog=this.querySelector('dialog');this.rail=this.querySelector('.nmo-rail');this.media=matchMedia('(max-width:767px)');
  this.addEventListener('click',e=>{
   if(this.suppressClick&&e.target.closest('.nmo-entry')){e.preventDefault();e.stopPropagation();this.suppressClick=false;return;}
   const trigger=e.target.closest('[data-nmo-open]');
   if(trigger&&this.media.matches){this.opener=trigger;this.querySelector('[data-nmo-title]').textContent=trigger.querySelector('strong').textContent;this.querySelectorAll('[data-nmo-screen]').forEach(x=>x.hidden=x.dataset.nmoScreen!==trigger.dataset.nmoOpen);this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.locked=true;this.dialog.showModal();this.dialog.scrollTop=0;if(trigger.dataset.nmoOpen==='wishlist')this.loadWishlist();return;}
   if(e.target.closest('[data-nmo-close]'))this.dialog.close();
   if(e.target.closest('[data-nmo-more]'))this.loadBatch();
  },{signal});
  this.dialog.addEventListener('close',()=>{this.restore();this.productController?.abort();},{signal});
  this.media.addEventListener('change',()=>{if(!this.media.matches&&this.dialog.open)this.dialog.close();},{signal});
  this.rail.addEventListener('pointerdown',e=>{this.suppressClick=false;if(e.pointerType!=='mouse'||e.button!==0)return;this.drag={x:e.clientX,scroll:this.rail.scrollLeft};},{signal});
  this.rail.addEventListener('pointermove',e=>{if(!this.drag)return;const delta=e.clientX-this.drag.x;if(Math.abs(delta)>6){this.suppressClick=true;this.rail.setPointerCapture(e.pointerId);this.rail.style.scrollSnapType='none';this.rail.scrollLeft=this.drag.scroll-delta;}},{signal});
  const end=()=>{this.drag=null;this.rail.style.scrollSnapType='';};this.rail.addEventListener('pointerup',end,{signal});this.rail.addEventListener('pointercancel',end,{signal});
 }
 restore(){if(this.locked){document.body.style.overflow=this.previousOverflow;this.locked=false;}if(this.media?.matches)this.opener?.focus({preventScroll:true});}
 loadWishlist(){
  this.productController?.abort();this.productController=new AbortController();this.querySelector('[data-nmo-saved]').replaceChildren();this.querySelector('[data-nmo-error]').hidden=true;this.querySelector('[data-nmo-more]').hidden=true;this.querySelector('[data-nmo-loading]').hidden=true;this.offset=0;this.loading=false;
  try{const saved=JSON.parse(localStorage.getItem('wishlistItem')||'[]');this.handles=Array.isArray(saved)?[...new Set(saved.filter(x=>typeof x==='string'&&/^[a-z0-9][a-z0-9-]{0,199}$/i.test(x)))]:[];}catch{this.handles=[];this.querySelector('[data-nmo-error]').hidden=false;}
  this.querySelector('[data-nmo-empty]').hidden=this.handles.length>0;this.loadBatch();
 }
 async loadBatch(){
  if(this.loading||this.offset>=this.handles.length)return;this.loading=true;const signal=this.productController.signal;const handles=this.handles.slice(this.offset,this.offset+8);this.offset+=handles.length;
  this.querySelector('[data-nmo-more]').hidden=true;this.querySelector('[data-nmo-loading]').hidden=false;
  const base=new URL(this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/',location.origin);const results=[];
  for(let start=0;start<handles.length;start+=4){if(signal.aborted)return;results.push(...await Promise.all(handles.slice(start,start+4).map(async handle=>{try{
   const url=new URL('products/'+encodeURIComponent(handle)+'.js',base);const response=await fetch(url,{method:'GET',signal:AbortSignal.any([signal,AbortSignal.timeout(10000)]),credentials:'same-origin'});if(!response.ok)throw Error('unavailable');const product=await response.json();if(product.handle!==handle||typeof product.title!=='string')throw Error('invalid');return {handle,product};
  }catch{return null;}})));}
  if(signal.aborted)return;
  for(const item of results){if(!item){this.querySelector('[data-nmo-error]').hidden=false;continue;}const link=document.createElement('a');link.href=new URL('products/'+encodeURIComponent(item.handle),base).href;
   if(item.product.featured_image){try{const imageUrl=new URL(item.product.featured_image,location.origin);if(imageUrl.protocol==='https:'&&(imageUrl.origin===location.origin||imageUrl.hostname==='cdn.shopify.com')){const image=document.createElement('img');image.src=imageUrl.href;image.alt='';image.loading='lazy';image.width=160;image.height=160;link.append(image);}}catch{}}
   const title=document.createElement('span');title.textContent=item.product.title;link.append(title);this.querySelector('[data-nmo-saved]').append(link);
  }
  this.loading=false;this.querySelector('[data-nmo-loading]').hidden=true;this.querySelector('[data-nmo-more]').hidden=this.offset>=this.handles.length;
 }
 disconnectedCallback(){this.controller?.abort();this.productController?.abort();if(this.dialog?.open)this.dialog.close();this.restore();this.connected=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nimall-service-banner-mobile-r1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nimall-service-strip')) {
  customElements.define('nimall-service-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.nss-slide')];
      this.current = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('pointerdown', e => { this.startX = e.clientX; this.startY = e.clientY; });
      this.addEventListener('pointerup', e => {
        const dx = e.clientX - this.startX;
        const dy = e.clientY - this.startY;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) { this.suppressClick = true; this.show(this.current + (dx < 0 ? 1 : -1)); }
      });
      this.addEventListener('click', e => { if (this.suppressClick) { e.preventDefault(); this.suppressClick = false; } }, true);
      this.timer = setInterval(() => {
        if (this.reduced.matches || document.visibilityState !== 'visible' || this.contains(document.activeElement)) return;
        const box = this.getBoundingClientRect();
        if (box.width && box.bottom > 0 && box.top < innerHeight) this.show(this.current + 1);
      }, 3000);
    }
    show(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.dataset.active = String(this.current);
      this.slides.forEach((slide, i) => {
        const active = i === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
        slide.inert = !active;
      });
    }
    disconnectedCallback() { clearInterval(this.timer); this.initialized = false; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nimall-variant-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nimall-variant-delivery')) {
    customElements.define('nimall-variant-delivery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.view = this.closest('.productView');
        this.shippingText = this.querySelector('[data-shipping-text]');
        this.estimateText = this.querySelector('[data-estimate-text]');
        try {
          this.deliveries = JSON.parse(this.querySelector('[data-delivery-variants]').textContent);
        } catch {
          this.deliveries = {};
        }
        this.refresh = () => {
          const selector = this.view?.querySelector('variant-selects, variant-radios');
          const input = document.getElementById(`product-form-${this.dataset.productId}`)?.querySelector('[name="id"]');
          this.showVariant(selector && 'currentVariant' in selector
            ? selector.currentVariant?.id : input?.value || this.dataset.initialVariant);
        };
        this.view?.addEventListener('change', this.refresh, {signal: this.controller.signal});
        window.addEventListener('popstate', this.refresh, {signal: this.controller.signal});
        this.refresh();
      }
      showVariant(variantId) {
        const data = Object.hasOwn(this.deliveries, String(variantId)) ? this.deliveries[String(variantId)] : null;
        const valid = Array.isArray(data) && data.length === 4 && data[0] === 'AE' && data[1] === 'Dubai'
          && Number.isSafeInteger(data[2]) && Number.isSafeInteger(data[3]) && data[2] > 0 && data[3] >= data[2];
        this.hidden = !valid;
        this.dataset.variantId = variantId == null ? '' : String(variantId);
        this.shippingText.textContent = valid ? this.dataset.shippingLabel : '';
        this.estimateText.textContent = valid ? this.dataset.estimateLabel.replace('{min}', String(data[2])).replace('{max}', String(data[3])) : '';
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nimall-wap-language"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nimall-wap-language')) {
    customElements.define('nimall-wap-language', class extends HTMLElement {
      connectedCallback() {
        if (this.languageReady) {
          document.addEventListener('pointerdown', this.onLanguageOutside);
          document.addEventListener('focusin', this.onLanguageOutside);
          window.addEventListener('pageshow', this.onLanguagePageShow);
          this.onLanguagePageShow();
          return;
        }
        const details = this.querySelector('details');
        const form = this.querySelector('form');
        const trigger = this.querySelector('summary');
        // Sticky search clones the already-enhanced header, whose wheel role
        // is now listbox. Initialize that copy with fresh IDs and listeners.
        const wheel = form?.querySelector('[role="group"], [role="listbox"]');
        const label = this.querySelector('.wap-language__label');
        if (!details || !form || !trigger || !wheel || !label) return;
        const options = [...wheel.querySelectorAll('button[name="language_code"]')];
        if (!options.length) return;
        const current = Math.max(0, options.findIndex(option => option.getAttribute('aria-current') === 'true'));
        const mobile = window.matchMedia('(max-width: 767px)');
        let selected = current;
        let intent = false;
        let touching = false;
        let submitting = false;
        let timer;
        let cycle = 0;
        const setBusy = value => {
          submitting = value;
          this.setAttribute('aria-busy', String(value));
        };
        const height = () => options[0].offsetHeight || 44;
        const select = index => {
          selected = Math.max(0, Math.min(options.length - 1, index));
          options.forEach((option, position) => option.setAttribute('aria-selected', String(position === selected)));
          wheel.setAttribute('aria-activedescendant', options[selected].id);
        };
        const close = focus => {
          clearTimeout(timer);
          intent = false;
          touching = false;
          cycle++;
          details.open = false;
          if (focus) trigger.focus({preventScroll: true});
        };
        const submit = () => {
          clearTimeout(timer);
          if (!details.open || !mobile.matches || touching || submitting) return;
          if (selected === current) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(options[selected]);
          else {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'language_code';
            input.value = options[selected].value;
            form.append(input);
            const returnTo = form.querySelector('[name="return_to"]');
            if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
            setBusy(true);
            HTMLFormElement.prototype.submit.call(form);
          }
        };
        const settle = () => {
          clearTimeout(timer);
          if (intent && !touching && details.open) timer = setTimeout(submit, 400);
        };
        const arm = () => { if (details.open && mobile.matches) intent = true; };
        this.classList.add('wap-language--wheel');
        wheel.classList.add('wap-language__wheel');
        wheel.setAttribute('role', 'listbox');
        wheel.setAttribute('aria-orientation', 'vertical');
        wheel.tabIndex = 0;
        window.nimallWapLanguageSequence = (window.nimallWapLanguageSequence || 0) + 1;
        const prefix = 'NimallWapLanguageWheel' + window.nimallWapLanguageSequence;
        wheel.id = prefix;
        label.id = prefix + 'Label';
        wheel.setAttribute('aria-labelledby', label.id);
        form.id = prefix + 'Form';
        trigger.setAttribute('aria-controls', prefix);
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', String(details.open));
        options.forEach((option, index) => {
          option.id = prefix + 'Option' + index;
          option.setAttribute('role', 'option');
          option.tabIndex = -1;
          option.addEventListener('click', event => {
            if (!mobile.matches) return;
            if (submitting) { event.preventDefault(); return; }
            event.preventDefault();
            select(index);
            if (selected === current) close(false);
            else submit();
          });
        });
        select(current);
        details.addEventListener('toggle', () => {
          trigger.setAttribute('aria-expanded', String(details.open));
          clearTimeout(timer);
          intent = false;
          if (!details.open) { touching = false; cycle++; return; }
          select(current);
          const opening = ++cycle;
          requestAnimationFrame(() => {
            if (opening !== cycle || !details.open) return;
            wheel.scrollTo({top: current * height(), behavior: 'instant'});
          });
        });
        wheel.addEventListener('wheel', arm, {passive: true});
        wheel.addEventListener('pointerdown', arm, {passive: true});
        wheel.addEventListener('touchstart', () => { arm(); touching = true; clearTimeout(timer); }, {passive: true});
        wheel.addEventListener('touchend', () => { touching = false; settle(); }, {passive: true});
        wheel.addEventListener('touchcancel', () => { touching = false; intent = false; clearTimeout(timer); }, {passive: true});
        wheel.addEventListener('scroll', () => {
          if (!details.open || !intent) return;
          select(Math.round(wheel.scrollTop / height()));
          settle();
        }, {passive: true});
        wheel.addEventListener('keydown', event => {
          if (submitting) { event.preventDefault(); return; }
          const targets = {ArrowDown: selected + 1, ArrowUp: selected - 1, Home: 0, End: options.length - 1};
          if (event.key in targets) {
            event.preventDefault();
            clearTimeout(timer);
            intent = false;
            select(targets[event.key]);
            wheel.scrollTo({top: selected * height(), behavior: 'instant'});
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (selected === current) close(true);
            else submit();
          }
        });
        this.onLanguageOutside = event => { if (!this.contains(event.target)) close(false); };
        document.addEventListener('pointerdown', this.onLanguageOutside);
        document.addEventListener('focusin', this.onLanguageOutside);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); close(true); }
        });
        form.addEventListener('submit', event => {
          if (submitting) { event.preventDefault(); return; }
          setBusy(true);
          clearTimeout(timer);
          const returnTo = form.querySelector('[name="return_to"]');
          if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
        });
        this.onLanguagePageShow = () => { setBusy(false); select(current); close(false); };
        window.addEventListener('pageshow', this.onLanguagePageShow);
        this.cancelLanguageTimer = () => { clearTimeout(timer); cycle++; };
        this.languageReady = true;
      }
      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onLanguageOutside);
        document.removeEventListener('focusin', this.onLanguageOutside);
        window.removeEventListener('pageshow', this.onLanguagePageShow);
        if (this.cancelLanguageTimer) this.cancelLanguageTimer();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
